"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Container for a value that is lazy-loaded whenever needed.
 * Further, it expires after a given time to avoid overly-stale data.
 */
class ExpiringValue {
    /**
     * Construct a new expiring value.
     *
     * @param factoryFn factory to lazy-load the value
     * @param ttl milliseconds the value is good for, after which it is reloaded.
     */
    constructor(factoryFn, ttl) {
        this.factoryFn = factoryFn;
        this.ttl = ttl;
        /** Epoch millisecond time of when the current value expires */
        this.expiration = 0;
    }
    /**
     * Get value; lazy-load from factory if not yet loaded or if expired.
     */
    get() {
        if (this.isExpired()) {
            this.value = this.factoryFn();
            this.expiration = Date.now() + this.ttl;
        }
        return this.value;
    }
    /**
     * Clear/expire the value now.
     * Following this with a get() will reload the data from the factory.
     */
    clear() {
        this.value = undefined;
        this.expiration = 0;
    }
    /**
     * Is the value expired (or not set)
     */
    isExpired() {
        return Date.now() > this.expiration;
    }
}
exports.ExpiringValue = ExpiringValue;
//# sourceMappingURL=expiring-value.js.map